// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type Check20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Check20: FC<Check20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M8.23 14.222 4.548 10.52l1.206-1.206 2.474 2.453 6.016-5.995L15.451 7 8.23 14.222Z" />
        </svg>
    );
};

export default Check20;
